
export class FechamentoMarcacao {

  idUserFechamento: number = 0;

  loginUserFechamento: string = '';

  dataFechamento: Date = new Date();

  dataFechamentoFormatada: string = '';
}
